import UserApi from '@/services/rest/bemob/user';
import store from '@/store';
import router from '@/routes';

export class SecuritylApi {

  loading: boolean = false;
  error: boolean = false;

  api: UserApi = new UserApi();

  dataApiKeys: object = {};
  newKey: object = {};

  dataSessions: object = {};

  dataTwoFactor: object = {};
  codeList: any = {};

  secretKey: string = '';

  getApiKeys() {
    this.loading = true;
    return this.api.getApiKeys().then((payload: any) => {
      this.dataApiKeys = payload;
      this.loading = false;
      return payload;
    });
  };

  postCreateApiKey(params) {
    this.loading = true;
    return this.api.postCreateApiKey({ params }).then((payload: any) => {
      this.newKey = payload;
      this.loading = false;
      return payload;
    });
  };

  patchApiKey(id: any, params) {
    return this.api.patchApiKey(id, params).then((payload: any) => {
      return Promise.resolve(payload);
    });
  };

  deleteApiKey(id: any) {
    return this.api.deleteApiKey(id).then((payload: any) => {
      return Promise.resolve(payload);
    });
  };

  getSessions() {
    this.loading = true;
    return this.api.getAccessTokens().then((payload: any) => {
      this.dataSessions = payload;
      this.loading = false;
      return payload;
    });
  }

  deleteSession(id: any) {
    this.loading = true;
    return this.api.deleteAccessToken(id).then((payload: any) => {
      this.dataSessions = payload;
      this.loading = false;
      return payload;
    });
  }

  deleteSessions() {
    this.loading = true;
    this.api.deleteAllAccessTokens().then((payload: any) => {
      this.dataSessions = payload ? payload : [];
      this.loading = false;
      
      store.commit('logout');
      router.push('/login');
      return payload;
    });
  }

  postTwoFactorGetQrCode(payload: object) {
    return this.api.postTwoFactorGetQrCode(payload).then((payload: any) => {
      this.codeList = payload;
      return payload
    });
  };

  postTwoFactorVerifyQrCode(payload: object) {
    this.loading = true;
    return this.api.postTwoFactorVerifyQrCode(payload).then((payload: any) => {
      this.dataTwoFactor = payload;
      this.loading = false;
      return payload
    });
  };

  postTwoFactorDisable(payload: object) {
    return this.api.postTwoFactorDisable(payload).then((payload: any) => {
      this.dataTwoFactor = payload;
      return payload
    });
  };

  getLandingSecretKey(){
    return this.api.getLandingSecretKey().then((payload: any) => {
      this.secretKey = payload.key;
      return payload
    });
  }

  putUser(payload: object){
    return this.api.putUser(payload).then((payload: any) => {
      return payload
    });
  }
}

export default new SecuritylApi();
